export default "__VITE_ASSET__DEHQM3x4__"